import React, { useEffect, useMemo, useState } from "react";
import ReactEchart from "../../../../../../molecules/ReactEchart";
import { EChartsOption } from "echarts";

const CategoryPieChart = () => {
//   const legendColors: { [key: string]: string } = {
//     "Air Conditioning": "#002f5c",
//     Carpentry: "#2ca5b9",
//     Electrical: "#ff6361",
//     Masonry: "#2c82c9",
//     Painting: "#009688",
//     Plumbing: "#30c36b",
//     "TV & Commu.": "#145da0",
//   };

const legendColors = useMemo(
    () => ({
      "Air Conditioning": "#002f5c",
      Carpentry: "#2ca5b9",
      Electrical: "#ff6361",
      Masonry: "#2c82c9",
      Painting: "#009688",
      Plumbing: "#30c36b",
      "TV & Commu.": "#145da0",
    }),
    []
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const options = useMemo<EChartsOption>(() => {
    return isMobile
      ? {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            bottom: 0,
            right: 30,
            icon: "none",
            itemGap: 30,
            textStyle: {
              fontSize: 14,
              fontWeight: "bold",
              rich: {
                b: {
                  fontWeight: "bold",
                  fontSize: 14,
                  color: "#145da0",
                },
                a: {
                  fontSize: 14,
                  color: "#666",
                },
              },
            },
            formatter: (name: string) => {
              const values: { [key: string]: string } = {
                "Air Conditioning": "20%",
                Carpentry: "1.3%",
                Electrical: "21.10%",
                Masonry: "20%",
                Painting: "10%",
                Plumbing: "40%",
                "TV & Commu.": "20%",
              };
              return `{b|${values[name]}} {a|${name} (2514)}`;
            },
          },
          toolbox: {
            show: false,
          },
          series: [
            {
              label: { show: false },
              type: "pie",
              radius: [10, 150],
              center: ["45%", "27%"],
              roseType: "area",
              itemStyle: {
                borderRadius: 8,
              },
              data: [
                {
                  value: 40,
                  name: "Air Conditioning",
                  itemStyle: { color: legendColors["Air Conditioning"] },
                },
                {
                  value: 38,
                  name: "Carpentry",
                  itemStyle: { color: legendColors["Carpentry"] },
                },
                {
                  value: 32,
                  name: "Electrical",
                  itemStyle: { color: "#ff6361" },
                },
                { value: 30, name: "Masonry", itemStyle: { color: "#2c82c9" } },
                {
                  value: 28,
                  name: "Painting",
                  itemStyle: { color: "#009688" },
                },
                {
                  value: 26,
                  name: "Plumbing",
                  itemStyle: { color: "#30c36b" },
                },
                {
                  value: 12,
                  name: "TV & Commu.",
                  itemStyle: { color: "#145da0" },
                },
              ],
            },
          ],
        }
      : {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            right: 10,
            top: "center",
            icon: "none",
            itemGap: 30,
            textStyle: {
              fontSize: 14,
              fontWeight: "bold",
              rich: {
                b: {
                  fontWeight: "bold",
                  fontSize: 14,
                  color: "#145da0",
                },
                a: {
                  fontSize: 14,
                  color: "#666",
                },
              },
            },
            formatter: (name: string) => {
              const values: { [key: string]: string } = {
                "Air Conditioning": "20%",
                Carpentry: "1.3%",
                Electrical: "21.10%",
                Masonry: "20%",
                Painting: "10%",
                Plumbing: "40%",
                "TV & Commu.": "20%",
              };
              return `{b|${values[name]}} {a|${name} (2514)}`;
            },
          },
          toolbox: {
            show: false,
          },
          series: [
            {
              label: { show: false },
              type: "pie",
              radius: [10, 150],
              center: ["25%", "50%"],
              roseType: "area",
              itemStyle: {
                borderRadius: 8,
              },
              data: [
                {
                  value: 40,
                  name: "Air Conditioning",
                  itemStyle: { color: legendColors["Air Conditioning"] },
                },
                {
                  value: 38,
                  name: "Carpentry",
                  itemStyle: { color: legendColors["Carpentry"] },
                },
                {
                  value: 32,
                  name: "Electrical",
                  itemStyle: { color: "#ff6361" },
                },
                { value: 30, name: "Masonry", itemStyle: { color: "#2c82c9" } },
                {
                  value: 28,
                  name: "Painting",
                  itemStyle: { color: "#009688" },
                },
                {
                  value: 26,
                  name: "Plumbing",
                  itemStyle: { color: "#30c36b" },
                },
                {
                  value: 12,
                  name: "TV & Commu.",
                  itemStyle: { color: "#145da0" },
                },
              ],
            },
          ],
        };
  }, [isMobile, legendColors]);

  return (
    <ReactEchart
      options={options}
      style={{
        height: isMobile ? "590px" : "390px",
        width: "100%",
      }}
    />
  );
};

export default CategoryPieChart;
